import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import styled from "styled-components";
import EditIcon from "../editicon.png";
import { CloseO } from "styled-icons/evil/CloseO";
import AddBranchClosure from "./AddBranchClosure";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { withRouter } from "react-router-dom";
import { deleteManagerHoliday } from "../../../../Actions";
import { dateFormat } from "../../../../Api/Utils/ReuseableFunctions";
import { format, differenceInDays } from "date-fns";
class BranchClosure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDataOpen: false,
      branchData: [],
      holidayDayEdit: undefined,
      heightSet: 0
    };
    this.openForm = this.openForm.bind(this);
    this.cancelForm = this.cancelForm.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  openForm() {
    this.setState(state => ({
      formDataOpen: true,
      holidayDayEdit: undefined
    }));
  }
  openEditForm = data => {
    this.setState(state => ({
      formDataOpen: true,
      holidayDayEdit: data
    }));
    this.updateHolidayDetails(data);
  };
  updateHolidayDetails = data => {
    return (
      <AddBranchClosure
        onClose={this.cancelForm}
        editHoliday={this.state.holidayDayEdit}
      />
    );
  };
  cancelForm() {
    this.setState(state => ({
      formDataOpen: false
    }));
  }
  componentDidUpdate(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        branchData: this.props.branchData
      });
      this.updateDimensions();
    }
  }
  componentDidMount() {
    if (this.props.branchData !== void 0) {
      this.setState({
        branchData: this.props.branchData
      });
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight });
  }
  DeleteHoliday = (Data, index) => {
    let payload = Data;
    payload.isDeactivated = "Y";

    this.props.dispatch(deleteManagerHoliday(payload));
  };
  render() {
    const { formDataOpen } = this.state;
    var updatedHt = this.state.heightSet - 285;
    const empDivStyle = {
      maxHeight: updatedHt + "px"
    };
    return (
      <MainApp>
        <ContainerDiv>
          <HeaderDiv>
            <HeadRow>
              <ColFirst lg="3">
                <Trans>closureDateRange</Trans>
              </ColFirst>
              <Col lg="2">
                <Trans>numberOfDays</Trans>
              </Col>
              <ColFirst lg="3">
                <Trans>description</Trans>
              </ColFirst>
              <Col lg="2">
                <Trans>edit</Trans>
              </Col>
              <Col lg="2">
                <Trans>remove</Trans>
              </Col>
            </HeadRow>
          </HeaderDiv>
          <ContentDiv style={empDivStyle}>
            {this.state.branchData.map((branchData, index) => (
              <ROW key={branchData.holidayNr}>
                <ColFirstHoli lg="3">
                  {branchData.holidayStartDate ? (
                    branchData.holidayEndDate ? (
                      branchData.holidayStartDate !==
                        branchData.holidayEndDate ? (
                          <>
                            {format(
                              dateFormat(branchData.holidayStartDate),
                              "EEE,dd MMM yyyy"
                            )}
                            {"-"}
                            {format(
                              dateFormat(branchData.holidayEndDate),
                              "EEE,dd MMM yyyy"
                            )}
                          </>
                        ) : (
                          format(
                            dateFormat(branchData.holidayStartDate),
                            "EEE,dd MMM yyyy"
                          )
                        )
                    ) : null
                  ) : null}
                  {/* {dateFormat(branchData.holidayStartDate) !==
                    dateFormat(branchData.holidayEndDate) &&
                    dateFormat(branchData.holidayEndDate)} */}
                </ColFirstHoli>
                <Col lg="2">
                  {branchData.holidayEndDate
                    ? differenceInDays(
                      dateFormat(branchData.holidayEndDate),
                      dateFormat(branchData.holidayStartDate)
                    ) + 1
                    : 1}
                </Col>
                <ColFirst lg="3">{branchData.holidayName}</ColFirst>
                <Col lg="2">
                  <ImageDiv onClick={() => this.openEditForm(branchData)}>
                    <Img src={EditIcon} alt="edit" />
                  </ImageDiv>
                </Col>
                <Col lg="2">
                  <CloseO
                    onClick={() => this.DeleteHoliday(branchData, index)}
                    size="20"
                  />
                </Col>
              </ROW>
            ))}
          </ContentDiv>
        </ContainerDiv>
        <FooterData
          formDataOpen={formDataOpen}
          heightData={this.state.heightSet}
        >
          {!formDataOpen ? (
            <p>
              <Btn onClick={this.props.BackTab}>
                <Trans>back</Trans>
              </Btn>
              <Btn onClick={this.openForm}>
                <Trans>create</Trans>
              </Btn>
            </p>
          ) : (
              this.updateHolidayDetails()
            )}
        </FooterData>
      </MainApp>
    );
  }
}

const mapStateToProps = ({
  auth,
  managerTimesheetData,
  holidayManager
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    userName: auth.appData.empName,
    branchData: managerTimesheetData.payload.branchClosureList,
    userDefault: auth.user.defaultProfile,
    holidayManager: holidayManager
  };
};
export default withRouter(
  connect(mapStateToProps)(withTranslation()(BranchClosure))
);

const MainApp = styled.div`
  position: relative;
  height: 100vh;
`;
const ContainerDiv = styled(Container)`
  width: 100%;
  float: center;
  font-family: Trebuchet MS;
  padding-top: 1%;
`;
const ColFirst = styled(Col)`
  text-align: left;
  padding-left: 20px;
`;
const ColFirstHoli = styled(Col)`
  padding-left: 6px;
  text-align: left;
`;
const ROW = styled(Row)`
  margin-left:0px !important
  margin-right:0px !important
  display: flex;
  flex-wrap: unset !important;
`;
const HeadRow = styled(Row)`
  display: flex;
  flex-wrap: unset !important;
`;
const HeaderDiv = styled.div`
  background: grey;
  height: 30px;
  background: #f1f4f9;
  font-weight: bold;
  font-size: 14px;
  border-radius: 4px;
  padding-top: 6px;
  padding-left: 31px;
  padding-right: 10px;
`;
const ContentDiv = styled.div`
  font-size: 16px;
  padding-top: 6px;
  padding-left: 31px;
  padding-right: 10px;
  line-height: 30px;
  overflow-y: auto;
`;
const Img = styled.img`
  height: 15px;
  width: 15px;
`;
const ImageDiv = styled.div``;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  text-align: center;
  position: fixed;
  bottom:0px
  right: 0px;
  width: 101%;
  margin-left: 4px;
  && p {
    bottom: 0px;
    position: absolute;
    width: 100%;
  }
  ${({ formDataOpen, heightData }) =>
    formDataOpen &&
    `
    position: absolute;
    bottom:134px
    height: 150px;
  `}
`;
const Btn = styled.button`
    background: #fff;
    border-radius: 30px;
    margin: 0 5px;
    padding: 0;
    border: 1px solid #babec3;
    height: 38px;
    width: 129px;
    font-weight: 50;
    position: relative;
    left: 8px;
    color: #000;
    font-size: 12px;
`;
